"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
window.Cookies = js_cookie_1.default;
;
(function (Drupal, once, cookies) {
    Drupal.behaviors.toggleCallToAction = {
        attach: function (context) {
            const openCallToAction = document.querySelector('.js-open-call-to-action');
            const callToAction = document.querySelector('.js-call-to-action');
            // Open call to action
            once('openCallToAction', '.js-open-call-to-action', context).forEach(function (element) {
                element.addEventListener('click', function (event) {
                    if (callToAction) {
                        // Open the call to action
                        if (callToAction.classList.contains('hidden')) {
                            callToAction.classList.remove('hidden', 'pointer-events-none', '-z-10');
                            callToAction.classList.remove('animate-slide-in-from-right-faster-delayed');
                            callToAction.classList.add('animate-slide-in-from-right-faster', 'z-40');
                            // Hide the open call to action component
                            openCallToAction === null || openCallToAction === void 0 ? void 0 : openCallToAction.classList.add('hidden');
                        }
                    }
                });
            }),
                // Close call to action
                once('closeCallToAction', '.js-close-call-to-action', context).forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        const callToAction = document.querySelector('.js-call-to-action');
                        const callToActionBlockId = callToAction === null || callToAction === void 0 ? void 0 : callToAction.getAttribute('block-id');
                        if (callToActionBlockId) {
                            const ctaId = `cta-closed-${callToActionBlockId}`;
                            if (cookies.get(ctaId)) {
                                cookies.remove(ctaId);
                            }
                            else {
                                cookies.set(ctaId, 'true');
                            }
                        }
                        // Hide the call to action component
                        callToAction === null || callToAction === void 0 ? void 0 : callToAction.classList.add('hidden', 'pointer-events-none', '-z-10');
                        callToAction === null || callToAction === void 0 ? void 0 : callToAction.classList.remove('animate-slide-in-from-right-faster', 'z-40');
                        // Show the open call to action component
                        openCallToAction === null || openCallToAction === void 0 ? void 0 : openCallToAction.classList.remove('hidden');
                    });
                });
        },
    };
})(Drupal, once, window.Cookies);
